// GENERATED by scripts/build-icons.mjs from icons/gauge.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Gauge = createIcon('gauge', [
  ['path', { d: "m12 14 4-4" }],
  ['path', { d: "M3.34 19a10 10 0 1 1 17.32 0" }],
])
